import type { GetResult } from '@fingerprintjs/fingerprintjs-pro'
import * as FingerprintJS from '@fingerprintjs/fingerprintjs-pro'

import { settings } from '@twisto/environment'
import { logger } from '@twisto/utils'

// we store the promise in a variable so that we can reuse it
// and not call FingerprintJS.load() multiple times
let resultPromise: Promise<FingerprintJSProResult> | null = null

const initFingerprintJSPro = () => {
  resultPromise = (async () => {
    // Initialize an agent at application startup.
    // requests from localhost and testserver are filtered https://dev.fingerprint.com/docs/request-filtering

    // We use FPJS Pro to get a unique identifier for the user: visiotrId and requestId.
    // The fp.twisto.<cc> custom subdomain and the twisto.<cc>/fp/ proxy loader were
    // removed together with the Fingerprint contract (TSD-9661, DO-3042), so the agent
    // uses the library's default endpoint and script URL.
    const fpPromise = FingerprintJS.load({
      apiKey: settings.FINGERPRINT_PRO_JS_PUBLIC_KEY,
    })

    const fpData = fpPromise
      .then((fp) => fp.get({ timeout: 12000 }))
      .catch((error) => {
        logger.logError('FingerprintJS Pro error', {
          error,
        })

        return null
      })

    return fpData
  })()
}

export type FingerprintJSProResult = Pick<
  GetResult,
  'requestId' | 'visitorId'
> | null

export const getFingerprintJSProPromise =
  async (): Promise<FingerprintJSProResult> => {
    if (resultPromise === null) {
      initFingerprintJSPro()
    }

    return resultPromise
  }
